<script module lang="ts">
	export const HelpLinks = [
		{
			label: 'HENI Customer Care',
			href: Links.Faq,
			newTab: true,
		},
		{
			label: 'Contact Us',
			href: Links.ContactUs,
			newTab: true,
		},
	];
</script>

<script lang="ts">
	import { FooterLinks, type FooterLink } from './FooterLinks';
	import FooterSocials from './FooterSocials/FooterSocials.svelte';
	import { Links } from '#lib/constants/links.js';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { page } from '$app/state';
	import { Container } from '$global/components/Container';

	// The footer stays a compact sitemap of the primary destinations rather
	// than mirroring every nav leaf. Specialist projects are surfaced in their
	// relevant page context instead of competing with these core journeys.
	const exploreLinks: FooterLink[] = [
		{ label: 'Artworks', href: GlobalRoutes.ArtworksHome },
		{ label: 'Editions', href: GlobalRoutes.EditionsHome },
		{ label: 'Primary', href: GlobalRoutes.PrimaryHome },
		{ label: 'Artists', href: GlobalRoutes.ArtistsHome },
		{ label: 'Shop', href: GlobalRoutes.ShopHome },
		{ label: 'Exhibitions', href: GlobalRoutes.ExhibitionsHome },
		{ label: 'HENI Gallery', href: GlobalRoutes.GalleryHome },
		{ label: 'Talks', href: GlobalRoutes.TalksHome },
		{ label: 'HENI News', href: GlobalRoutes.NewsHome },
		{ label: 'Publishing', href: GlobalRoutes.PublishingHome },
	];

	const scrollIntoView = (node: HTMLElement) => {
		if (window.location.href.endsWith('#heni-footer')) {
			node.scrollIntoView();
		}
	};
</script>

<!-- eslint-disable-next-line svelte/valid-compile -->
<footer use:scrollIntoView class="overflow-hidden bg-gray-900 md:min-h-[25rem]">
	<Container
		dataCy="footer"
		class="sm: flex flex-col items-stretch justify-center py-16 md:flex-row"
	>
		<FooterSocials class="mb-12 md:mb-0" />
		<FooterLinks
			dataCy="footer-explore"
			links={exploreLinks}
			title="Explore"
			class="mb-12 md:mb-0 md:pl-8"
			listClass="grid-cols-2 gap-x-10"
		/>
		<FooterLinks
			title="HENI"
			links={page.data.footer.links}
			class="mb-12 md:mb-0 md:pl-8"
			dataCy="footer-links"
		/>
		<FooterLinks
			dataCy="footer-links"
			links={page.data.footer.helpLinks || HelpLinks}
			title="Help"
		/>
	</Container>
</footer>
